import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { WebhookDelivery } from "types/generated";

import WebhookDeliveriesStatus from "../../Status";

const WebhookDeliveriesTableStatusCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<WebhookDelivery>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <WebhookDeliveriesStatus status={item.status} />
    </TableSimpleCell>
  );
};

export default WebhookDeliveriesTableStatusCell;
